import React, { useEffect, useMemo, useState } from 'react';
import CardLayout from '../../components/utils/CardLayout';
import Table from '../../components/utils/Table';
import pageAccessActions from "../../redux/pageAccess/actions";
import { useDispatch, useSelector } from 'react-redux';
import genericActions from "../../redux/generic/actions";
import ToastAlert from '../../components/utils/ToastAlert';
import Button from '../../components/utils/Button';

const { getPanelAccess, resetMessage, updatePanelAccess } = pageAccessActions;
const { getACode } = genericActions;


const PageAccess = () => {
  const dispatch = useDispatch();
  const [searchItem, setSearchItem] = useState("");
  const { aCodeList, getACodeLoading } = useSelector(state => state.generic);
  const { panelAccessList, getPanelAccessLoading, getPanelAccessError,
    updatePanelAccessMessage,
    updatePanelAccessLoading,
    updatePanelAccessError, } = useSelector(state => state.pageAccess);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedACodeData, setSelectedACodeData] = useState({});
  const [updatedPanelAccessList, setUpdatedPanelAccessList] = useState([]);

  useEffect(() => {
    dispatch(getACode());
  }, [])

  useEffect(() => {
    setUpdatedPanelAccessList(panelAccessList || []);
  }, [panelAccessList]);

  useEffect(() => {
    if (getPanelAccessError) {
      ToastAlert({ type: "error", text: getPanelAccessError });
    }

    if (updatePanelAccessError) {
      ToastAlert({ type: "error", text: updatePanelAccessError });
    }

    if (updatePanelAccessMessage) {
      ToastAlert({ type: "success", text: updatePanelAccessMessage });
      handleBack()
    }
  }, [getPanelAccessError, updatePanelAccessError, updatePanelAccessMessage]);


  const filteredItems = useMemo(() => {
    return Array.isArray(aCodeList)
      ? aCodeList.filter(itm => itm?.Id != 1).filter((item) => {
        if (!searchItem) return true;
        return Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchItem.toLowerCase())
        );
      })
      : [];
  }, [aCodeList, searchItem]);

  const columns = [
    { displayName: "Sr.No.", key: "key", },
    { displayName: "ACode", key: "aCode", },
     { displayName: "Dealer ID", key: "DealerID", },
    { displayName: "Action", key: "action", },
  ];

  const dataSource = useMemo(() => {
    return filteredItems.map((item, index) => ({
      key: index + 1,
      aCode: item?.ACode ?? "-",
      DealerID: item?.DealerID ?? "-",
      action: <button type="button" className="btn btn-sm rounded-circle btn-primary-light bg-primary-subtle"
        style={{ width: "32px", height: "32px", }}
        title="Edit" onClick={() => handleUpdatePanelAccess(item)} >
        <i className="ri-edit-line fw-bold" />
      </button>,
    }));
  }, [filteredItems]);


  const handleUpdatePanelAccess = (item) => {
    dispatch(getPanelAccess({ distributorId: Number(item?.Id) }))
    setSelectedACodeData(item)
    setShowEdit(true)
  }

  const handleBack = () => {
    setShowEdit(false)
    setSelectedACodeData({})
    dispatch(resetMessage())
  }

  const editColumns = [
    { displayName: "Sr.No.", key: "key", },
    { displayName: "Page Name", key: "pageName", },
    {
      displayName: (
        <>
          Action
          <input type="checkbox" className='form-check-input ms-2'
            onChange={(e) => setUpdatedPanelAccessList((prev) =>
              prev.map((item) => ({
                ...item,
                STATUS: e.target.checked,
              })))} /></>
      ),
      key: "status",
    }
    // { displayName: "Action", key: "status", },
  ];

  const handleCheckBox = (item, checked) => {
    setUpdatedPanelAccessList((prevList) =>
      prevList.map((data) =>
        data.ID === item.ID ? { ...data, STATUS: checked } : data
      )
    );
  };

  const editData = useMemo(() => {
    if (!updatedPanelAccessList?.length) {
      return [];
    }

    return updatedPanelAccessList.map((item, index) => ({
      key: index + 1,
      pageName: item?.TEXT ?? "-",
      status: (
        <div className="form-check mb-0">
          <input
            type="checkbox"
            className="form-check-input"
            checked={item?.STATUS === true}
            onChange={(e) => handleCheckBox(item, e.target.checked)}
            style={{
              width: "18px",
              height: "18px",
              marginTop: "0",
            }}
          />
        </div>
      ),
    }));
  }, [updatedPanelAccessList]);


  const handleUpdate = () => {
    const updatedPanel = updatedPanelAccessList && updatedPanelAccessList.length > 0 && updatedPanelAccessList.map((item) => {
      return {
        "pageId": item?.ID,
        "pageName": String(item?.TEXT),
        "status": item?.STATUS ? 1 : 0,
      };
    });

    const payload = {
      "distributorId": Number(selectedACodeData?.Id) || 0,
      pageStatusList: updatedPanel
    }
    dispatch(updatePanelAccess(payload))
  }


  return (
    <CardLayout
      title={<> Page Access {showEdit && <span style={{ color: "#4b9b60" }}> :#{selectedACodeData?.ACode} </span>} </>}
      icon="fas fa-user-lock"
      rightContent={
        showEdit ? <div className="d-flex gap-2">
          <Button
            title="Back"
            buttonType="button"
            icon={<i className="ri-arrow-left-line me-1" />}
            variant="primary"
            style={{ marginBottom: '1px' }}
            onClick={() => handleBack()}
          />
        </div> : <div className="d-flex align-items-center gap-2">
          {/* Search */}
          <div style={{ width: "300px" }}>
            <input
              type="search"
              className="form-control"
              placeholder="Search..."
              value={searchItem}
              onChange={(e) => setSearchItem(e.target.value)}
            />
          </div>
        </div>
      }>

      {/* Table */}
      <div>
        {showEdit ? <div>
          <Table
            columns={editColumns}
            loading={getPanelAccessLoading}
            data={editData}
            tableHeight="380px"
            sortConfigFlag={false}

          />
          <div className='d-flex justify-content-end gap-2 mt-3'>
            <Button
              title="Update"
              buttonType="button"
              icon={<i className="ri-send-plane-fill me-1" />}
              variant="primary"
              style={{ marginBottom: '1px' }}
              onClick={handleUpdate}
              disable={updatePanelAccessLoading}
              loading={updatePanelAccessLoading}
            />

            <Button
              title="Close"
              buttonType="button"
              icon={<i className="ri-close-circle-line me-1" />}
              variant="secondary"
              style={{ padding: "5px 10px", }}
              onClick={() => handleBack()}
              disable={updatePanelAccessLoading}
            />

          </div>
        </div> : <Table
          columns={columns}
          loading={getACodeLoading}
          data={dataSource}
          pagination={true}
          tableHeight="415px"
        />}
      </div>

    </CardLayout>
  )
}

export default PageAccess
